import React, { useEffect, useState } from 'react'
import { getProductsByCategory } from "../api";
import ProductGrid from './ProductGrid';

const PAGE_SIZE = 18;

// Reloads when the category changes, e.g. moving to a product in another category.
const SimilarProducts = ({ categoryId }) => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let ignore = false;
    setLoading(true);
    setProducts([]);
    getProductsByCategory(categoryId, 0, PAGE_SIZE)
      .then((data) => {
        if (ignore) return;
        const content = data.products.content;
        setProducts(Array.from(new Map(content.map((p) => [p.id, p])).values()));
      })
      .catch((error) => console.error("Error searching products:", error))
      .finally(() => {
        if (!ignore) setLoading(false);
      });
    return () => {
      ignore = true;
    };
  }, [categoryId]);

  if (loading) return <p>Loading products...</p>;
  return (
    <section className="trending-products pt-50 mt-24">
      <h5 className="mb-0">Related Products</h5>
      <ProductGrid products={products} showLoadmore={false} />
    </section>
  );
};

export default SimilarProducts;
